import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import TitleTextBlock from "../components/title-text-block";
import Tryptych from "../components/tryptych";
import Dyptych from "../components/dyptych";
import RowPhotoBlock from "../components/row-photo-block";
import guidePhotoPdf from '../public/download/guide-photos-2023-lucie-doret.pdf';
import ExternalLink from "../core/external-link";

//Images
import comServiceLeft from '../public/images/Services/Com-lancement.png'
import comServiceMiddle from '../public/images/Services/Com-developpement.png'
import comServiceRight from '../public/images/Services/Com-premium.png'
import illuServiceLeft from '../public/images/Services/Illu-traditionnel.png'
import illuServiceRight from '../public/images/Services/Illu-numerique.png'
import mdServiceLeft from '../public/images/Services/Motion-RS.gif'
import mdServiceRight from '../public/images/Services/Motion.gif'
import servicePrivateIndividual from '../public/images/Services/Particulier.png'


const ServicesPage: React.FunctionComponent = () => {
    const { t } = useTranslation();
    return (
        <>
            <section>
                <div className="w-75 m-auto pb-5 pt-5">
                    <TitleTextBlock title="services.title" text="services.text"/>
                </div>
                <div className="w-75 m-auto">
                    <TitleTextBlock title="services.part.0.title" text="services.part.0.text"/>
                </div>
                <div className="w-75 m-auto">
                    <Tryptych
                              left={{title: "services.part.0.presentation.left.title", text: "services.part.0.presentation.left.text", image: comServiceLeft, price: "À partir de 525€"}}
                              middle={{title: "services.part.0.presentation.middle.title", text: "services.part.0.presentation.middle.text", image: comServiceMiddle, price: "À partir de 600€"}}
                              right={{title: "services.part.0.presentation.right.title", text: "services.part.0.presentation.right.text", image: comServiceRight, price: "À partir de 800€"}}/>
                </div>
            </section>
            <section className="Background-light">
                <div className="w-75 m-auto">
                    <TitleTextBlock title="services.part.1.title" text="services.part.1.text"/>
                </div>
                <div className="w-75 m-auto">
                    <Dyptych
                              left={{title: "services.part.1.presentation.left.title", text: "services.part.1.presentation.left.text", image: illuServiceLeft, price: "À partir de 150€"}}
                              right={{title: "services.part.1.presentation.right.title", text: "services.part.1.presentation.right.text", image: illuServiceRight, price: "À partir de 200€"}}/>
                </div>
            </section>
            <section>
                <div className="w-75 m-auto">
                    <TitleTextBlock title="services.part.2.title" text="services.part.2.text"/>
                </div>
                <div className="w-75 m-auto">
                    <Dyptych
                              left={{title: "services.part.2.presentation.left.title", text: "services.part.2.presentation.left.text", image: mdServiceLeft, price: "À partir de 300€"}}
                              right={{title: "services.part.2.presentation.right.title", text: "services.part.2.presentation.right.text", image: mdServiceRight, price: "Sur devis"}}/>
                </div>
            </section>
            <section className="Background-light">
                <div className="w-75 m-auto pt-3">
                    <h1 className="Title-primary pb-4">{t("services.private-individual.title")}</h1>
                <RowPhotoBlock block={<>
                    <TitleTextBlock text="services.private-individual.text"/>
                    <ExternalLink link={guidePhotoPdf}><Button variant='light' className="Button-primary Text-light">{t('button.download-photo-guide')}</Button></ExternalLink></>
                } image={servicePrivateIndividual} imageRight={true}/>      
                </div>
                <div className="w-75 m-auto pt-5">
                    <TitleTextBlock title="advertising.private-individual.title" text="advertising.private-individual.text"/>
                    <Button variant='light' href="/contact" className="Button-primary Text-light">{t('button.contacts')}</Button>
                </div>
            </section>

        </>
    )
  }

export default ServicesPage;